<script>
export default {
    name: "shopping",
    data() {
        return {};
    },
    computed: {},
    components: {},
    mounted() {},
    destroyed() {},
    watch: {},
    methods: {
    },
};
</script>

<template>
    <div class="shopping layout_main">
        <p class="title"><span :class="{active: $route.path == '/shopping'}">购物车</span> · <span :class="{active: $route.path == '/shopping/order'}">送货地址</span> · <span :class="{active: $route.path == '/shopping/pay'}">结账</span></p>
        <div class="vip">
            <p>立即成为 Ambassador<sup>+</sup>会员 可享10%优惠 , 免费参观所有展览，享受学习课程折扣</p>
            <p class="freight_free">订单超过300RMB在中国境内免费送货</p>
        </div>
        <router-view></router-view>
    </div>
</template>

<style scoped lang="scss">
.shopping{
    padding: .8rem 0;
}
.title{
    font-size: .18rem;
    margin-bottom: .4rem;
    color: #999;
    span{
        &.active{
            color: var(--font_color);
        }
    }
    @media only screen and (max-width: 750px) {
        text-align: center;
        font-size: .36rem;
    }
}
.vip{
    text-align: center;
    font-size: .18rem;
    margin-bottom: .7rem;
    line-height: 1.6;
    .freight_free{
        color: #666;
    }
    @media only screen and (max-width: 750px) {
        font-size: .28rem;
        color: #666;
    }
}
</style>
<style lang="scss">
.shopping{
    .list{
        .item{
            padding: .4rem 0;
            border-bottom: 1px solid #999;
            @media only screen and (max-width: 750px) {
                padding: .3rem 0;
            }
            .wrapper{
                gap: .4rem;
                @media only screen and (max-width: 750px) {
                    gap: .2rem;
                }
            }
            .cover{
                width: 2rem;
                height: 2.3rem;
                // border: 1px solid #000;
            }
            .content{
                flex: 1;
                padding-top: .2rem;
                .info{
                    width: 4rem;
                    font-size: .18rem;
                    color: #666;
                    line-height: 1.8;
                    .name{
                        a{
                            &:hover{
                                border-bottom: 1px solid #666;
                            }
                        }
                    }
                    @media only screen and (max-width: 750px) {
                        font-size: .28rem;
                    }
                }
            }
            .bottom{
                gap: .4rem;
                .btn_del{
                    color: #666;
                    font-size: .18rem;
                    cursor: pointer;
                    border-bottom: 1px solid #666;
                    user-select: none;
                    &.confirm{
                        color: var(--font_color);
                        font-weight: bold;
                    }
                }
                .price{
                    font-size: .22rem;
                }
                @media only screen and (max-width: 750px) {
                    gap: .2rem;
                    .btn_del{
                        font-size: .26rem;
                    }
                    .price{
                        font-size: .26rem;
                    }
                }
            }
        }
    }
}
.shopping_price{
    // border-bottom: 1px solid #999;
    .content{
        font-size: .18rem;
        width: 17em;
        padding: .3rem 0;
        @media only screen and (max-width: 750px) {
            width: 100%;
        }
        .row{
            padding: .1rem 0;
            margin-bottom: .2rem;
            border-bottom: 1px solid #b1b1b1;
            &:last-child{
                margin-bottom: 0;
            }
            @media only screen and (max-width: 750px) {
                padding: .2rem 0;
            }
        }
        .text{
            font-size: .18rem;
            color: #666;
            @media only screen and (max-width: 750px) {
                font-size: .26rem;
            }
        }
        .price_wrap{
            .name{
                font-size: .18rem;
                color: #666;
            }
            .price{
                font-size: .26rem;
            }
            @media only screen and (max-width: 750px) {
                .name,
                .price{
                    font-size: .26rem;
                }
            }
        }
        .btn{
            width: 100%;
            height: .6rem;
            border: 1px solid #999;
            cursor: pointer;
            color: #666;
            &::after{
                content: "";
                display: block;
                width: .08rem;
                height: .08rem;
                border-right: 1px solid #666;
                border-top: 1px solid #666;
                transform: rotate(45deg);
                margin-left: .06rem;
            }
            @media only screen and (max-width: 750px) {
                font-size: .25rem;
                height: .7rem;
                // margin-bottom: .2rem;
                &::after{
                    width: .1rem;
                    height: .1rem;
                }
            }
        }
    }
}
</style>